import {Injectable} from '@angular/core';
import {SystemApiClient} from "../clients/system-api/SystemApiClientp";
import {
  AdministrationResultStatus,
  PaginationArgs,
  ServiceDataPaginationDataAdministrationResult, UserProfileData,
  UserProfileDataAdministrationResult,
  UserProfileDataPaginationDataAdministrationResult,
  UserRoleData, UserRoleDataAdministrationResult, UserRoleDataListAdministrationResult
} from "../clients/system-api/SystemApiClient";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private apiClient: SystemApiClient) {
  }

  retrieveAllUsers(isEmployee: boolean, args: PaginationArgs,): Observable<UserProfileDataPaginationDataAdministrationResult> {
    return this.apiClient.retrieveAllUsersPaginated(isEmployee, args);
  }

  retrieveUserById(id: number): Observable<UserProfileDataAdministrationResult> {
    return this.apiClient.retrieveUserById(id);
  }

  editUser(userData: UserProfileData): Observable<AdministrationResultStatus> {
    return this.apiClient.editUser(userData);
  }

  addUser(userData: UserProfileData): Observable<AdministrationResultStatus> {
    return this.apiClient.addUser(userData);
  }

  retrieveUserRoles(): Observable<UserRoleDataListAdministrationResult> {
    return this.apiClient.retrieveAllUserRoles();
  }

}
